<template>
    <div style="min-height: 200px;" v-loading="loading" element-loading-text="查询中..." v-cloak>
        <el-input class="mt5 mb10" placeholder="输入关键字进行过滤" v-if="enableSearch != null && enableSearch == true" v-model="filterText">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="handleFilterTextClick"></i>
        </el-input>
        <!--<el-input v-if="enableSearch != null && enableSearch == true" class="mt5 mb10" placeholder="输入关键字进行过滤" icon="search" v-model="" :on-icon-click="handleFilterTextClick"></el-input>-->
        <el-tree ref="categTree" :data="dataList" :load="loadNode" lazy="" node-key="id" :filter-node-method="filterNode" :highlight-current="highlightCurrent" :props="defaultProps" :render-content="renderContent" :default-expanded-keys="defaultExpandedKeys"></el-tree>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, filterByName, Routes } from '../../app.vues'
    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-servicer-com-tree-multi-select',
        desc: '机构树列表 - 多选(支持三级，现在最少最后一级可被选择，可自定义第一级和第二级)',
        props: {
            enableSearch: {
                type: Boolean,
                default: true
            },
            showCheckboxLevel1: { // 第一级节点是否可被选择，默认否
                type: Boolean,
                default: false
            },
            showCheckboxLevel2: { // 第二级节点是否可被选择，默认否
                type: Boolean,
                default: false
            },
            showCheckboxLevel3: { // 第三级节点是否可被选择，默认否
                type: Boolean,
                default: false
            },
            checkStrictly: { //TODO 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法，默认为 false，相互关联只支持下级节点禁用
                type: Boolean,
                deafult: false,
            },
            defaultCheckedItems: {// 回显的数据ids
                type: Array,
                default: function () {
                    return [];
                }
            },
            model: { // 数据模型
                type: Object,
                default: function () {
                    let model = {};
                    model.comIdColumn = "comId"; //
                    model.comNameColumn = "comName";
                    model.comLevelColumn = "comLevel";
                    return model;
                }
            },
            bizDepart: {
                type: Boolean,
                default: false
            },
            bizUnitId: {
                type: Number,
                default: null
            }
        },
        watch: {},
        data: function () {
            return {
                bizUnit : false,
                loading: false,
                highlightCurrent: true,
                filterText: "",
                dataList: [],
                defaultProps: {
                    children: 'comSons',
                    label: 'name'
                },
                defaultExpandedKeys: [],
                checkComIds: [],
                checkComList: []
            }
        },
        created: function () {
            this.bizUnit = !this.bizDepart;
            //
            let model = this.model;
            //
            let defaultCheckedItems = this.defaultCheckedItems;
            //
            let comIds = defaultCheckedItems.pluck(model.comIdColumn);
            this.checkComIds = comIds;
            this.checkComList = defaultCheckedItems;
            //
            let comId1s = defaultCheckedItems.pluck(model.comIdColumn + 1);
            let comId2s = defaultCheckedItems.pluck(model.comIdColumn + 2);
            let comId3s = defaultCheckedItems.pluck(model.comIdColumn + 3);
            this.defaultExpandedKeys = comId1s.concat(comId2s).concat(comId3s);
        },
        methods: {
            handleFilterTextClick: function () {
                let filterText = this.filterText;
                //
                let postData = {};
                postData.bizUnit = this.bizUnit;
                postData.lazyFlag = false;
                postData.includeUnOpenedFlag = this.includeUnOpenedFlag;
                postData.name = filterText;
                postData.isCom = true;
                if(Utils.isNoB(this.includeClosed) || this.includeClosed == false) {
                    postData.closed = false
                }
                let self = this;
                let theLoad = MsgBox.loading();
                servicerApi.getServicerComList(postData, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let data = result.data;
                        //
                        //对树节点数据进行过滤处理（设置 nodeKey）
                        self.mergeCheckComList(data);
                        //
                        let comList = Utils.merge([], data);
                        //
                        let nodeKey = [];
                        let comIds = result.codeName || null;
                        if(!Utils.isNoB(comIds)) {
                            nodeKey = JSON.decode(comIds) || [];
                        }
                        self.comList = comList;
                        self.defaultExpandedKeys = Utils.merge([], nodeKey);
                    } else {
                        self.comList = [];
                        self.$message.error(result.message);
                    }
                });
            },
            getLazyComList: function (parentId) {
                let self = this;
                let postData = {};
                postData.bizUnit = this.bizUnit;
                postData.lazyFlag = true;
                postData.includeUnOpenedFlag = this.includeUnOpenedFlag;
                postData.parentId = parentId || null;
                postData.isCom = true;
                if(Utils.isNoB(this.includeClosed) || this.includeClosed == false) {
                    postData.closed = false
                }
                servicerApi.getServicerComList(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        //对树节点数据进行过滤处理（设置 nodeKey）
                        self.mergeCheckComList(data);
                        //
                        self.comList = data;
                    } else {
                        self.$message.error(result.message);
                    }
                })
            },
            //
            mergeCheckComList: function (dataList) {
                if(dataList != null && dataList.length > 0) {
                    let checkComIds = this.checkComIds;
                    let checkComList = this.checkComList;
                    let model = this.model;
                    //
                    for(let i = 0; i < dataList.length; i++) {
                        let comInfo = dataList[i];
                        if(checkComIds.contains(comInfo.id)) {
                            //
                            let item = checkComList.find(function (elem, index) {
                                return elem[model.comIdColumn] == comInfo.id;
                            });
                            item[model.comNameColumn] = comInfo.name;
                            item[model.comLevelColumn] = comInfo.level;
                        }
                    }
                }
            },
            loadNode(node, resolve) {
                let self = this;
                let dbChildren = node.data.children || [];
                if(dbChildren != null && dbChildren.length > 0) {
                    return resolve(dbChildren);
                }
                //
                if(node.level === 0) {
                    this.getLazyComList();
                } else {
                    if(node.level >= 10) {
                        return resolve(dbChildren);
                    }
                    let parentId = node.data.id;
                    if(this.bizUnit) {
                        parentId = node.data.bizUnitId;
                    }
                    let postData = {};
                    postData.bizUnit = this.bizUnit;
                    postData.lazyFlag = true;
                    postData.parentId = parentId;
                    postData.includeUnOpenedFlag = this.includeUnOpenedFlag;
                    postData.isCom = true;
                    if(Utils.isNoB(this.includeClosed) || this.includeClosed == false) {
                        postData.closed = false
                    }
                    //
                    servicerApi.getServicerComList(postData, function (result) {
                        if(result.type == 'info') {
                            let data = result.data;
                            self.mergeCheckComList(data);
                            resolve(data);
                        } else {
                            resolve([]);
                            self.$message.warning(result.message);
                        }
                    });
                }
            },
            filterNode(value, data) {
                if(!value) {
                    return true;
                }
                return data.name.indexOf(value) !== -1;
            },
            renderContent: function (createElement, node) {
                //设置叶子节点标记（不然会出现多余的箭头）
                node.node.isLeaf = node.data.leafFlag;
                //
                let selfTree = this;
                return createElement({
                    data: function () {
                        return {
                            item: node,
                            checkComIds: selfTree.checkComIds,
                            checkComList: selfTree.checkComList,
                            showCheckboxLevel1: selfTree.showCheckboxLevel1,
                            showCheckboxLevel2: selfTree.showCheckboxLevel2,
                            showCheckboxLevel3: selfTree.showCheckboxLevel3,
                            checkStrictly: selfTree.checkStrictly,
                        };
                    },
                    template: '' +
                    '<span>' +
                    '<span v-if = "item.data.level == 1">' +
                    '<el-checkbox v-if = "showCheckboxLevel1" :checked = "checkComIds.indexOf(item.data.id) >= 0" @change ="handleCheckedChange(item.data)" :label="item.data.id">{{item.data.name}}</el-checkbox>' +
                    '<span v-else>{{item.data.name}}</span>' +
                    '</span>' +
                    '<span v-if = "item.data.level == 2">' +
                    '<el-checkbox v-if = "showCheckboxLevel2" :disabled = "!checkStrictly && checkComIds.indexOf(item.data.parentId) >= 0" :checked = "checkComIds.indexOf(item.data.id) >= 0" :label="item.data.id" @change ="handleCheckedChange(item.data)">{{item.data.name}}</el-checkbox>' +
                    '<span v-else>{{item.data.name}}</span>' +
                    '</span>' +
                    '<span v-if = "item.data.level == 3">' +
                    '<el-checkbox v-if = "showCheckboxLevel3" :disabled = "!checkStrictly && (checkComIds.indexOf(item.data.parentId) >= 0 || checkComIds.indexOf(item.data.comId1) >= 0)" :checked = "checkComIds.indexOf(item.data.id) >= 0" :label="item.data.id" @change ="handleCheckedChange(item.data)">{{item.data.name}}</el-checkbox>' +
                    '<span v-else>{{item.data.name}}</span>' +
                    '</span>' +
                    '<el-checkbox v-else-if = "item.data.level >= 4" :disabled = "!checkStrictly && (checkComIds.indexOf(item.data.parentId) >= 0 || checkComIds.indexOf(item.data.comId1) >= 0 || checkComIds.indexOf(item.data.comId2) >= 0)" :checked = "checkComIds.indexOf(item.data.id) >= 0" :label="item.data.id" @change ="handleCheckedChange(item.data)">{{item.data.name}}</el-checkbox>' +
                    '</span>',
                    methods: {
                        handleCheckedChange: function (value) {
                            let model = selfTree.model;
                            //
                            let checkComIds = selfTree.checkComIds;
                            let checkComList = selfTree.checkComList;
                            //
                            if(checkComIds.indexOf(value.id) >= 0) {
                                checkComIds.remove(value.id);
                                //
                                let item = checkComList.find(function (elem, index) {
                                    return elem[model.comIdColumn] == value.id;
                                });
                                checkComList.remove(item);
                            } else {
                                checkComIds.push(value.id);
                                //
                                let item = {};
                                item[model.comIdColumn] = value.id;
                                item[model.comNameColumn] = value.name;
                                item[model.comLevelColumn] = value.level;
                                item[model.comIdColumn + 1] = value.comId1;
                                item[model.comIdColumn + 2] = value.comId2;
                                item[model.comIdColumn + 3] = value.comId3;
                                checkComList.push(item);
                                // console.log(item);
                                // 删除下级选中
                                let checkStrictly = selfTree.checkStrictly;
                                if(!checkStrictly && value.level <= 2) {
                                    for(let i = 0; i < checkComList.length; i++) {
                                        let checkedCat = checkComList[i];
                                        if(checkedCat[model.comIdColumn + value.level] == value.id && checkedCat[model.comIdColumn] != value.id) {
                                            checkComIds.remove(checkedCat[model.comIdColumn]);
                                            checkComList.splice(i, 1);
                                            i--;
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            },
            notityChange: function () {
                // 发生变化时向上传递
                this.$emit('notity-change', this.checkComList);
            },
            getDlgResult(){
                let result = {};
                if(this.checkComList != null && this.checkComList.length > 0) {
                    result.type = 'info';
                    result.data = this.checkComList;
                } else {
                    result.type = 'warn';
                    result.message = '请选择机构';

                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/ComTreeMultiSelect.vue